var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_12578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6719 19.9999C14.5012 20.0005 14.3325 19.9628 14.1782 19.8897C14.024 19.8165 13.8881 19.7097 13.7805 19.5771L8.26106 12.7206C8.09298 12.5161 8.0011 12.2597 8.0011 11.995C8.0011 11.7303 8.09298 11.4738 8.26106 11.2693L13.9748 4.41282C14.1688 4.17945 14.4475 4.0327 14.7497 4.00484C15.0519 3.97698 15.3527 4.07029 15.5861 4.26426C15.8195 4.45823 15.9662 4.73696 15.9941 5.03913C16.0219 5.34131 15.9286 5.64217 15.7346 5.87554L10.6266 12.0007L15.5632 18.1258C15.703 18.2936 15.7917 18.4978 15.819 18.7144C15.8463 18.931 15.811 19.1509 15.7172 19.3481C15.6234 19.5452 15.4752 19.7114 15.2899 19.8269C15.1047 19.9424 14.8902 20.0025 14.6719 19.9999Z",
    fill: "#1B1C1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_12578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon_arrow_left.53cabf39c5b98db6e25242943bb72018.svg";
export { ForwardRef as ReactComponent };